/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Ortak konuşma amacı ve sürümlü AI istemci sözleşmesi. Tek kaynak Core'dur.
 */
import { PageTabs } from "./PageTabs";
import {
  assistantPurposeCopy,
  type AssistantConversationPurpose,
} from "./assistant-conversation-purpose";
import "./AssistantPurposeSelector.css";

export function AssistantPurposeSelector({
  value,
  onChange,
  language = "tr",
}: {
  value: AssistantConversationPurpose;
  onChange: (value: AssistantConversationPurpose) => void;
  language?: string;
}) {
  const copy = assistantPurposeCopy(language);
  return (
    <div className="qp-assistant-purpose">
      <PageTabs
        items={[
          { value: "BUSINESS", label: copy.business },
          { value: "QUBEPRO_HELP", label: copy.help },
        ]}
        value={value}
        onChange={onChange}
        ariaLabel={copy.label}
        variant="segmented"
        overflow="wrap"
      />
      <p className="qp-assistant-purpose__hint">
        {value === "QUBEPRO_HELP" ? `${copy.helpHint} ${copy.hint}` : copy.hint}
      </p>
    </div>
  );
}
